import { API } from "../../Services";
import customers from "../../Services/Apis/customers";

export const partnerleadlist = (query='') =>{
    return (dispatch) =>{
        dispatch({
            type:"FETCH_PARTNER_LEAD_LIST",
        })
    
        API.partnerleadlist(query).then((res)=>{
            console.log(res);
            let data = JSON.parse(JSON.stringify(res)).data.leads
           
            setTimeout(()=>{
                dispatch({
                    type:"RECEIVE_PARTNER_LEAD_LIST",
                    payload:{data:data,totalRecords:res.data.totalRecords},
                })
            },1000)
        }).catch((err)=>{
            let data = JSON.parse(JSON.stringify(err?.response?.data?.message))

            dispatch({
                type:"ERROR_PARTNER_LEAD_LIST",
                payload:data

            })
        })
    }
}

